import React from "react";
import Contact from "../components/contact";
import EMICalculator from "../components/emiCalculator/emiCalculator";
import Popup from "../components/popup";
import HeroSlider from "../components/heroSlider";
import NoticePanel from "../components/noticePanel";
import {
	HomeAbout,
	HomeServices,
	NewsAndDownloads,
	RemittancePartners,
} from "../components/homeSections";

const Home = () => {
	return (
		<div className='home'>
			<Popup />

			<section className='hero'>
				<div className='container hero-grid'>
					<HeroSlider />
					<NoticePanel />
				</div>
			</section>

			<HomeAbout />
			<HomeServices />
			<NewsAndDownloads />
			<div id='emi'>
				<EMICalculator />
			</div>
			<RemittancePartners />
			<Contact />
		</div>
	);
};

export default Home;
